type FormatOptions = {
    maskedNumberReplacement?: string;
};

export const formatCardNumber = (cardNumber: string, options: FormatOptions = {}): string => {
    const fixedCardNumber = cardNumber.replace(/\*/g, 'x').replace(/\s/g, '');
    const cleanedNumber = fixedCardNumber.replace(/x/g, options.maskedNumberReplacement ?? 'x');

    if (cleanedNumber.length !== 16) {
        return cardNumber;
    }

    const regExp = /(.{4})(.{4})(.{4})(.{4})/;

    return cleanedNumber.replace(regExp, '$1 $2 $3 $4');
};
